import {
	KActionDialog,
	KDataTable,
	KDataTableMenu
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";
import { formatCurrency } from "kinnect-formatters";

export default KDataTable.extend( {
	name: "KSalesOrdersErrorsTable",

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no sales order errors to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching sales order errors found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "salesOrderNumbers"
		}
	},

	computed: {
		canEditSalesOrders() {
			return this.$can( "edit_sales_orders" );
		},

		defaultHeaders() {
			return [
				{
					text: "Associated SO#",
					value: "salesOrderNumbers"
				},
				{
					text: "Error Type(s)",
					value: "errorTypeNames"
				},
				{
					text: "Error Notes",
					value: "error"
				},
				{
					text: "Error Cost",
					value: "cost"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteError( salesOrderError ) {
			const deleteIndex = this.items.findIndex( item => salesOrderError.id === item.id );

			return salesOrderError
			.delete()
			.then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.cost": ( { item } ) => (
					item.cost
						? formatCurrency( item.cost )
						: "--"
				),

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "salesSalesOrderError",
								params: { idError: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{this.canEditSalesOrders && <KActionDialog
								confirmButtonColor="error"
								confirmButtonText="Delete"
								loading={this.$wait.is( "delete sales order error" )}
								onConfirm={() => this.deleteError( item )}
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								title="Delete Sales Order Error"
							>
								Are you sure you want to delete the sales order error with the description <strong>{item.error}</strong>?
							</KActionDialog>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
